// extracted by mini-css-extract-plugin
export default {"dtg-layout-auth__offline-indicator":"dtg-layout-auth__offline-indicator_vB7Cq"};